'use client';

import { UserContext } from '@/_contexts/UserProvider';
import { useContext } from 'react';
import { AdminDashboard } from '@/_components/AdminDashboard';

export default function Home() {
  const { isLoggedIn, isAdvisor } = useContext(UserContext);

  if (!isAdvisor || !isLoggedIn) return null;

  return <AdminDashboard />;
}
